import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import MeshBackground from "@/components/MeshBackground";
import NavMenu from "@/components/NavMenu";
import Seo from "@/components/Seo";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Terms from "@/pages/Terms";
import AcceptableUse from "@/pages/AcceptableUse";
import AccountDeletion from "@/pages/AccountDeletion";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="relative min-h-screen font-['Manrope'] text-white">
        <MeshBackground />
        <NavMenu />
        <Seo />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/acceptable-use" element={<AcceptableUse />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Toaster position="bottom-center" theme="dark" />
      </div>
    </BrowserRouter>
  );
}

export default App;
